import { connect } from 'react-redux'
import { goBack } from 'connected-react-router'
import { createSelector } from 'reselect'
import SetupMFATOTP from '../../pages/SetupMFATOTP'
import { getUser } from '../../selectors/initialization'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { getSetupMFATOTP } from '../../selectors/setupMFATOTP'
import { getShouldSetupMFA } from '../../selectors/settings'
import {
  prepareTOTPRegistration,
  finishTOTPRegistration
} from '../../actions/setupMFATOTP'

export const mapStateToProps = createSelector(
  [getUser, getSetupMFATOTP, getShouldSetupMFA],
  (user, setupMFATOTP, shouldSetupMFA) => ({
    user,
    displayLogoutMenuOnly: shouldSetupMFA,
    ...setupMFATOTP
  })
)

export const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(goBack()),
  onPrepareRegistration: () => dispatch(prepareTOTPRegistration()),
  onFinishRegistration: ({ registrationToken, otp }) =>
    dispatch(finishTOTPRegistration({ registrationToken, otp }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCenteredBaseWithMenu(SetupMFATOTP))
